import { SeoPage, SeoReplaceValues } from 'libs/shared-lib/interfaces';
export const ABOUT_US_SEO_FR: SeoPage = {
    title: `${SeoReplaceValues.DEALER_NAME}: À propos de nous`,
    description: '',
    image: '',
    twitter: {
        card: 'summary',
        title: `${SeoReplaceValues.DEALER_NAME}: À propos de nous`,
        description: '',
    },
    og: {
        title: `${SeoReplaceValues.DEALER_NAME}: À propos de nous`,
        description: '',
    },
    robots: {
        noIndex: false,
        noFollow: false,
    },
};
